import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { getShareableLinkRoute } from '@confluence/ssr-app/entry-points/routes.ts';

import { ContentExtensionsProvider } from '../../ContentExtensionsProvider/index.ts';

export const ShareableLinkRoute = getShareableLinkRoute({
	ContextProvider: ContentExtensionsProvider,
	NotFound,
});
